export default __webpack_public_path__ + "static/media/intro.7e67e7ec.jpg";